import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('cbdce-alphabet-tabs', (fragmentElement, configuration, meta) => {
    const container = fragmentElement.querySelector<HTMLDivElement>('.cbdce-alphabet-tabs');
    if (!container) return;

    const tabs = Array.from(container.querySelectorAll<HTMLButtonElement>('[role="tab"]'));
    const panels = Array.from(container.querySelectorAll<HTMLDivElement>('[role="tabpanel"]'));

    /**
     * Updates the UI state for tabs and panels
     */
    const switchTab = (newTab: HTMLButtonElement, shouldFocus: boolean = true) => {
        const targetPanelId = newTab.getAttribute('aria-controls');

        tabs.forEach((tab) => {
            const isActive = tab === newTab;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive.toString());
        });

        panels.forEach((panel) => {
            const isTarget = panel.id === targetPanelId;
            panel.hidden = !isTarget;
            // Optionally add a class for CSS animations
            panel.classList.toggle('is-active', isTarget);
        });

        if (shouldFocus) {
            newTab.focus();
        }
    };

    tabs.forEach((tab) => {
        panels.forEach((panel) => {
            if(tab.id.slice(-1) === panel.id.slice(-1) && panel.firstElementChild?.children.length === 0 && !document.body.classList.contains('has-edit-mode-menu')) {
                panel.setAttribute('disabled', '');
                tab.setAttribute('disabled', '');
            } else {
                tab.addEventListener('click', () => switchTab(tab));
            }
        });
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
}
